import { Stack, Typography } from '@mui/material';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { LassoTab, LassoTabs } from '../../components/LassoTabs';
import CohortDemographics from './components/CohortDemographics';
import ResearchDomains from './components/ResearchDomains';
import { useLocation, useNavigate } from "react-router-dom";

enum Tabs {
    Cohort = "cohort",
    Research = "research"
}

type Views = "chart" | "table";

const Dashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const urlHashSelected = location.hash;
    const tabValue: Tabs = (urlHashSelected ? urlHashSelected : Tabs.Cohort).replace("#", "") as Tabs

    const [view, setView] = useState<Views>("chart");
    const [tab, setTab] = useState<Tabs>(tabValue);

    useEffect(() => {
        setTab(tabValue);
    }, [location.hash, tabValue]);

    const handleTabChange = (event: SyntheticEvent<Element, Event>, value: any) => {
        navigate({ hash: value }, { replace: true });
        setTab(value);
    }

    return (
        <Stack height={"100%"} marginX="24px" paddingTop="32px" paddingBottom={2} gap={3}>
            <Stack flexDirection={"row"} alignItems={"center"} gap={4}>
                <Typography fontSize={"32px"} fontWeight={"600"}>Explore and Search Data</Typography>
                <LassoTabs value={tab} onChange={handleTabChange}>
                    <LassoTab label={"By Cohort Demographics"} value={Tabs.Cohort}/>
                    <LassoTab label={"By Research Domains"} value={Tabs.Research}/>
                </LassoTabs>
            </Stack>
            {tab === Tabs.Cohort ?
                <CohortDemographics view={view} setView={setView}/> :
                <ResearchDomains view={view} setView={setView}/>}
        </Stack>
    )
}

export default Dashboard;
